import React, { useEffect, useState } from 'react'
import { Button, Spinner, Row, Col, Form, Badge } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { RequiredLabel } from '../utils/validators';
import { getConceptsById, updateConcepts, activateConcept } from '../services/Concepts';

function EditConcept() {
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);

  const [description, setDescription] = useState('');
  const [isActive, setIsActive] = useState(true);
  const [originalIsActive, setOriginalIsActive] = useState(true);

  const navigate = useNavigate();
  const redirectBack = () => navigate(`/concepts`);

  useEffect(() => {
    (async () => {
      try {
        const c = await getConceptsById(id);
        if (!c) {
          toast.error('No se pudo cargar el concepto');
          return;
        }
        setDescription(c.description || '');
        setIsActive(!!c.isActive);
        setOriginalIsActive(!!c.isActive);
      } catch (e) {
        toast.error('No se pudo cargar el concepto');
      } finally {
        setIsLoading(false);
      }
    })();
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!description.trim()) return toast.warn('El nombre es requerido');

    try {
      setIsSaving(true);

      // 1) actualizar texto
      await updateConcepts(id, { description });

      // 2) si cambió el estatus, actualizarlo
      if (isActive !== originalIsActive) {
        await activateConcept(id, isActive);
      }

      toast.success('Concepto actualizado');
      navigate('/concepts');
    } catch (err) {
      console.error(err);
      toast.error('No se pudo actualizar el concepto');
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div>
      {isLoading ? (
        <Spinner animation="border" role="status" />
      ) : (
        <Form onSubmit={handleSubmit}>
          <Form.Group controlId="formConceptName" className="mb-3">
            <Form.Label as={RequiredLabel} required>Nombre:</Form.Label>
            <Form.Control
              type="text"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              maxLength={350}
            />
          </Form.Group>

          <Form.Group controlId="formConceptActive" className="mb-3">
            <Form.Check
              type="switch"
              id="concept-active-switch"
              label={isActive ? 'Activo' : 'Inactivo'}
              checked={isActive}
              onChange={(e) => setIsActive(e.target.checked)}
            />
          </Form.Group>

          <Row>
            <Col xl={12} className='text-center'>
              <Button className='m-3' variant="secondary" type="button" onClick={redirectBack} disabled={isSaving}>
                Cancelar o regresar
              </Button>
              <Button className='m-3' variant="primary" type="submit" disabled={isSaving}>
                {isSaving ? 'Guardando...' : 'Guardar cambios'}
              </Button>
            </Col>
          </Row>
        </Form>
      )}
      <ToastContainer />
    </div>
  );
}

export default EditConcept;